import React, { FunctionComponent } from 'react'
import { T } from '@transifex/react'
import { useFormatCurrencyValue } from '../../helpers/formatNumberHooks'

/** Sell-step body: the seeded price is fixed at 1, shown in the outlet's currency (e.g. "$1.00"). */
export const SsboSellStepBody: FunctionComponent = () => {
  const formatCurrencyValue = useFormatCurrencyValue()

  return (
    <T
      _str='We added a temporary {price} item to your cart. Tap "Pay" to continue.'
      _context="SSBO guided tour step body"
      price={formatCurrencyValue(1)}
    />
  )
}
